export const STEPS = {
  S0: 'S0',
  S1: 'S1',
};

export const initialState = {
  step: STEPS.S0,
  query: '',
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'FOCUS_INPUT':
      return { ...state, step: STEPS.S1 };

    case 'QUERY_CHANGED':
      return { ...state, step: STEPS.S1, query: action.query };

    case 'CLOSE_PANEL':
      return { ...state, step: STEPS.S0 };

    case 'CLEAR':
      return { ...state, query: '' };

    case 'HYDRATE':
      return action.snapshot;

    default:
      return state;
  }
};
